// Post-submit summary modal: how many words were created, merged into existing
// originals, and failed. Failed rows stay flagged in the list for a retry, so on
// a partial failure closing returns to the session; on full success the caller
// discards the session.
import type { SubmitSummary } from '@/lib/bulk-add/bulk-session';
import { createPortal } from 'react-dom';

interface BulkSummaryDialogProps {
  summary: SubmitSummary;
  onClose: () => void;
}

/** Submit-result summary dialog. */
export function BulkSummaryDialog({ summary, onClose }: BulkSummaryDialogProps) {
  const hasFailures = summary.failed > 0;

  const dialog = (
    <dialog open className="bulk-overlay" aria-modal="true" aria-label="Résultat de l'ajout">
      <div className="bulk-dialog bulk-dialog--confirm">
        <h2 className="bulk-dialog__title">Ajout terminé</h2>
        <ul className="bulk-summary">
          <li>
            <strong>{summary.created}</strong> mot{summary.created > 1 ? 's' : ''} créé
            {summary.created > 1 ? 's' : ''}
          </li>
          {summary.merged > 0 && (
            <li>
              <strong>{summary.merged}</strong> fusionné{summary.merged > 1 ? 's' : ''} avec un
              original
            </li>
          )}
          {hasFailures && (
            <li className="bulk-summary__fail">
              <strong>{summary.failed}</strong> échec{summary.failed > 1 ? 's' : ''} — à réessayer
            </li>
          )}
        </ul>
        <div className="bulk-dialog__actions">
          <button type="button" className="bulk-btn bulk-btn--primary" onClick={onClose}>
            {hasFailures ? 'Revenir à la revue' : 'Terminé'}
          </button>
        </div>
      </div>
    </dialog>
  );

  return createPortal(dialog, document.body);
}
